export default "__VITE_ASSET__B_8w3Vz7__"